b247.newsletter = function() {

  //var newsletter = $('[data-newsletter]'); // Blocking this action for now

  return;

  var newsletter = null;

  if (newsletter.length) {

    newsletter.each(function() {

      var target = $(this);

      target.ajaxChimp({
        callback: function(response) {

          target.find('.newsletter__message').remove();

          if (response.result === 'success') {

            target.prepend('<p class="newsletter__message newsletter__mesage--success">Almost finished...we need to confirm your email address.  Please click the link in the email we just sent you.</p>');

          } else {

            var message = response.msg;

            target.prepend('<p class="newsletter__message newsletter__mesage--fail">' + message.replace('0 - ', '') + '</p>');

          }

        }
      });

    });

  }

};

$('[data-newsletter]').on('submit', function (e) {

	e.preventDefault();

	window.dataLayer.push({
		'event': 'event-to-ga',
		'eventCategory' : $(this).data('newsletter-ga-category'),
		'eventAction' : $(this).data('newsletter-ga-action'),
		'eventLabel' : $(this).data('newsletter-ga-label')
	});


	this.submit();
	return false;
});